import firebase from "firebase";
import { uploadFile } from "@/services/storage-service.js";

export async function updateInscription(sympId, inscriptionId, data) {
  // Add a new document in collection "cities"
  console.log("sympId", sympId);
  console.log("inscriptionId", inscriptionId);
  console.log("updateInscription", data);
  firebase
    .firestore()
    .collection("symposiums")
    .doc(sympId)
    .collection("inscriptions2025")
    .doc(inscriptionId)
    .set(data)
    .then(() => {
      console.log("Document successfully written!");
    })
    .catch((error) => {
      console.error("Error writing document: ", error);
    });
}
export async function deleteInscription(sympId, inscriptionId) {
  // Add a new document in collection "cities"
  firebase
    .firestore()
    .collection("symposiums")
    .doc(sympId)
    .collection("inscriptions2025")
    .doc(inscriptionId)
    .delete()
    .then(() => {
      console.log("Document successfully deleted!");
    })
    .catch((error) => {
      console.error("Error deleting document: ", error);
    });
}
export async function getInscriptions(sympId) {
  console.log("getInscriptions");
  var inscriptions = [];
  var querySnapshot = await firebase
    .firestore()
    .collection("symposiums")
    .doc(sympId)
    .collection("inscriptions2025")
    .get();
  querySnapshot.forEach((doc) => {
    // doc.data() is never undefined for query doc snapshots
    inscriptions.push({ id: doc.id, ...doc.data() });
  });
  return inscriptions;
}
export async function getInscription(simposioId, inscriptionId) {
  console.log("getInscriptions");
  var docRef = await firebase
    .firestore()
    .collection("symposiums")
    .doc(simposioId)
    .collection("inscriptions2025")
    .doc(inscriptionId);
  var docSnap = await docRef.get();
  if (docSnap.exists) {
    console.log("Document data:", docSnap.data());
    var inscription = { id: docSnap.id, ...docSnap.data() };
    console.log("inscription", inscription);
    return inscription;
  } else {
    // doc.data() will be undefined in this case
    console.log("No such document!");
  }
}
export async function createInscription(data, curriculum, letter) {
  console.log("createInscription");
  // Add a new document with a generated id.
  var doc = await firebase
    .firestore()
    .collection("symposiums")
    .doc(data.sympId)
    .collection("inscriptions2025")
    .doc();
  //console.log("Document created with ID: ", doc.id)
  await uploadFile(curriculum, "2024/" + doc.id + "_CV.pdf");
  //console.log('uploadFile1', uploadFile1);
  await uploadFile(letter, "2024/" + doc.id + "_letter.pdf");
  //console.log('uploadFile2', uploadFile2);
  const firebaseCreateResponse = await doc.set(data);
  //console.log('firebaseCreateResponse', firebaseCreateResponse);
  return firebaseCreateResponse;
}
